export const invoicePaymentTranslations = {
  en: {
    'invoicePayment.loading': 'Loading invoice details...',
    'invoicePayment.notFound': 'Invoice Not Found',
    'invoicePayment.notFoundDesc': "The invoice you're looking for doesn't exist or you don't have permission to view it.",
    'invoicePayment.returnHome': 'Return Home',
    'invoicePayment.backHome': 'Back Home',
    'invoicePayment.title': 'Invoice {{key}}',
    'invoicePayment.created': 'Created {{timeAgo}}',
    'invoicePayment.summary': 'Invoice Summary',
    'invoicePayment.paid': 'Fully Paid',
    'invoicePayment.due': 'Payment Due',
    'invoicePayment.totalAmount': 'Total Amount',
    'invoicePayment.amountPaid': 'Amount Paid',
    'invoicePayment.amountDue': 'Amount Due',
    'invoicePayment.paymentsMade': 'Payments Made',
    'invoicePayment.description': 'Description',
    'invoicePayment.expires': 'Expires',
    'invoicePayment.history': 'Payment History',
    'invoicePayment.received': 'Payment received',
    'invoicePayment.from': 'from {{name}}',
    'invoicePayment.paidTitle': 'Invoice Paid',
    'invoicePayment.paidDesc': 'This invoice has been fully paid. Thank you!',
    'invoicePayment.toast.error': 'Error',
    'invoicePayment.toast.errorDesc': 'Failed to load invoice details.',
    'invoicePayment.toast.success': 'Payment Successful',
    'invoicePayment.toast.successDesc': 'Successfully paid for invoice {{key}}',
    'invoicePayment.toast.fail': 'Payment Failed',
    'invoicePayment.toast.failDesc': 'Failed to process payment. Please try again.',
    'invoicePayment.loadingError': 'Unable to load invoice details',
  },
  es: {
    'invoicePayment.loading': 'Cargando detalles de la factura...',
    'invoicePayment.notFound': 'Factura no encontrada',
    'invoicePayment.notFoundDesc': 'La factura que buscas no existe o no tienes permiso para verla.',
    'invoicePayment.returnHome': 'Volver al Inicio',
    'invoicePayment.backHome': 'Volver al Inicio',
    'invoicePayment.title': 'Factura {{key}}',
    'invoicePayment.created': 'Creada {{timeAgo}}',
    'invoicePayment.summary': 'Resumen de la Factura',
    'invoicePayment.paid': 'Totalmente Pagada',
    'invoicePayment.due': 'Pago Pendiente',
    'invoicePayment.totalAmount': 'Importe Total',
    'invoicePayment.amountPaid': 'Importe Pagado',
    'invoicePayment.amountDue': 'Importe Adeudado',
    'invoicePayment.paymentsMade': 'Pagos Realizados',
    'invoicePayment.description': 'Descripción',
    'invoicePayment.expires': 'Vence',
    'invoicePayment.history': 'Historial de Pagos',
    'invoicePayment.received': 'Pago recibido',
    'invoicePayment.from': 'de {{name}}',
    'invoicePayment.paidTitle': 'Factura Pagada',
    'invoicePayment.paidDesc': 'Esta factura ha sido pagada en su totalidad. ¡Gracias!',
    'invoicePayment.toast.error': 'Error',
    'invoicePayment.toast.errorDesc': 'No se pudieron cargar los detalles de la factura.',
    'invoicePayment.toast.success': 'Pago Exitoso',
    'invoicePayment.toast.successDesc': 'Se pagó con éxito la factura {{key}}',
    'invoicePayment.toast.fail': 'Pago Fallido',
    'invoicePayment.toast.failDesc': 'No se pudo procesar el pago. Por favor, inténtalo de nuevo.',
  },
  fr: {
    'invoicePayment.loading': 'Chargement des détails de la facture...',
    'invoicePayment.notFound': 'Facture introuvable',
    'invoicePayment.notFoundDesc': 'La facture que vous recherchez n\'existe pas ou vous n\'avez pas la permission de la voir.',
    'invoicePayment.returnHome': 'Retour à l\'accueil',
    'invoicePayment.backHome': 'Retour à l\'accueil',
    'invoicePayment.title': 'Facture {{key}}',
    'invoicePayment.created': 'Créée {{timeAgo}}',
    'invoicePayment.summary': 'Résumé de la facture',
    'invoicePayment.paid': 'Entièrement payée',
    'invoicePayment.due': 'Paiement dû',
    'invoicePayment.totalAmount': 'Montant total',
    'invoicePayment.amountPaid': 'Montant payé',
    'invoicePayment.amountDue': 'Montant dû',
    'invoicePayment.paymentsMade': 'Paiements effectués',
    'invoicePayment.description': 'Description',
    'invoicePayment.expires': 'Expire',
    'invoicePayment.history': 'Historique des paiements',
    'invoicePayment.received': 'Paiement reçu',
    'invoicePayment.from': 'de {{name}}',
    'invoicePayment.paidTitle': 'Facture payée',
    'invoicePayment.paidDesc': 'Cette facture a été entièrement payée. Merci !',
    'invoicePayment.toast.error': 'Erreur',
    'invoicePayment.toast.errorDesc': 'Échec du chargement des détails de la facture.',
    'invoicePayment.toast.success': 'Paiement réussi',
    'invoicePayment.toast.successDesc': 'Facture {{key}} payée avec succès',
    'invoicePayment.toast.fail': 'Échec du paiement',
    'invoicePayment.toast.failDesc': 'Échec du traitement du paiement. Veuillez réessayer.',
  },
  sq: {
    'invoicePayment.loading': 'Duke ngarkuar detajet e faturës...',
    'invoicePayment.notFound': 'Fatura nuk u gjet',
    'invoicePayment.notFoundDesc': 'Fatura që po kërkoni nuk ekziston ose nuk keni leje ta shikoni.',
    'invoicePayment.returnHome': 'Kthehu në shtëpi',
    'invoicePayment.backHome': 'Kthehu në shtëpi',
    'invoicePayment.title': 'Fatura {{key}}',
    'invoicePayment.created': 'Krijuar {{timeAgo}}',
    'invoicePayment.summary': 'Përmbledhje Fature',
    'invoicePayment.paid': 'E Paguar Plotësisht',
    'invoicePayment.due': 'Pagesa e Detyruar',
    'invoicePayment.totalAmount': 'Shuma Totale',
    'invoicePayment.amountPaid': 'Shuma e Paguar',
    'invoicePayment.amountDue': 'Shuma e Detyruar',
    'invoicePayment.paymentsMade': 'Pagesat e Bëra',
    'invoicePayment.description': 'Përshkrimi',
    'invoicePayment.expires': 'Skadon',
    'invoicePayment.history': 'Historia e Pagesave',
    'invoicePayment.received': 'Pagesa e marrë',
    'invoicePayment.from': 'nga {{name}}',
    'invoicePayment.paidTitle': 'Fatura e Paguar',
    'invoicePayment.paidDesc': 'Kjo fatura është paguar plotësisht. Faleminderit!',
    'invoicePayment.toast.error': 'Gabim',
    'invoicePayment.toast.errorDesc': 'Dështoi ngarkimi i detajeve të faturës.',
    'invoicePayment.toast.success': 'Pagesa e Suksesshme',
    'invoicePayment.toast.successDesc': 'U pagua me sukses fatura {{key}}',
    'invoicePayment.toast.fail': 'Pagesa Dështoi',
    'invoicePayment.toast.failDesc': 'Dështoi përpunimi i pagesës. Ju lutem provoni përsëri.',
  },
  ru: {
    'invoicePayment.loading': 'Загрузка деталей счета...',
    'invoicePayment.notFound': 'Счет не найден',
    'invoicePayment.notFoundDesc': 'Счет, который вы ищете, не существует или у вас нет разрешения на его просмотр.',
    'invoicePayment.returnHome': 'Вернуться на главную',
    'invoicePayment.backHome': 'Вернуться на главную',
    'invoicePayment.title': 'Счет {{key}}',
    'invoicePayment.created': 'Создан {{timeAgo}}',
    'invoicePayment.summary': 'Сводка счета',
    'invoicePayment.paid': 'Полностью оплачен',
    'invoicePayment.due': 'Оплата требуется',
    'invoicePayment.totalAmount': 'Общая сумма',
    'invoicePayment.amountPaid': 'Оплаченная сумма',
    'invoicePayment.amountDue': 'Сумма к оплате',
    'invoicePayment.paymentsMade': 'Выполненные платежи',
    'invoicePayment.description': 'Описание',
    'invoicePayment.expires': 'Истекает',
    'invoicePayment.history': 'История платежей',
    'invoicePayment.received': 'Платеж получен',
    'invoicePayment.from': 'от {{name}}',
    'invoicePayment.paidTitle': 'Счет оплачен',
    'invoicePayment.paidDesc': 'Этот счет полностью оплачен. Спасибо!',
    'invoicePayment.toast.error': 'Ошибка',
    'invoicePayment.toast.errorDesc': 'Не удалось загрузить детали счета.',
    'invoicePayment.toast.success': 'Платеж успешен',
    'invoicePayment.toast.successDesc': 'Успешно оплачен счет {{key}}',
    'invoicePayment.toast.fail': 'Платеж не удался',
    'invoicePayment.toast.failDesc': 'Не удалось обработать платеж. Пожалуйста, попробуйте снова.',
  },
  pt: {
    'invoicePayment.loading': 'Carregando detalhes da fatura...',
    'invoicePayment.notFound': 'Fatura Não Encontrada',
    'invoicePayment.notFoundDesc': 'A fatura que você está procurando não existe ou você não tem permissão para visualizá-la.',
    'invoicePayment.returnHome': 'Voltar para Início',
    'invoicePayment.backHome': 'Voltar para Início',
    'invoicePayment.title': 'Fatura {{key}}',
    'invoicePayment.created': 'Criada {{timeAgo}}',
    'invoicePayment.summary': 'Resumo da Fatura',
    'invoicePayment.paid': 'Totalmente Paga',
    'invoicePayment.due': 'Pagamento Pendente',
    'invoicePayment.totalAmount': 'Valor Total',
    'invoicePayment.amountPaid': 'Valor Pago',
    'invoicePayment.amountDue': 'Valor Devido',
    'invoicePayment.paymentsMade': 'Pagamentos Realizados',
    'invoicePayment.description': 'Descrição',
    'invoicePayment.expires': 'Expira',
    'invoicePayment.history': 'Histórico de Pagamentos',
    'invoicePayment.received': 'Pagamento recebido',
    'invoicePayment.from': 'de {{name}}',
    'invoicePayment.paidTitle': 'Fatura Paga',
    'invoicePayment.paidDesc': 'Esta fatura foi totalmente paga. Obrigado!',
    'invoicePayment.toast.error': 'Erro',
    'invoicePayment.toast.errorDesc': 'Falha ao carregar detalhes da fatura.',
    'invoicePayment.toast.success': 'Pagamento Bem-sucedido',
    'invoicePayment.toast.successDesc': 'Pagamento realizado com sucesso para a fatura {{key}}',
    'invoicePayment.toast.fail': 'Pagamento Falhou',
    'invoicePayment.toast.failDesc': 'Falha ao processar pagamento. Por favor, tente novamente.',
  },
  el: {
    'invoicePayment.loading': 'Φόρτωση λεπτομερειών τιμολογίου...',
    'invoicePayment.notFound': 'Το Τιμολόγιο Δεν Βρέθηκε',
    'invoicePayment.notFoundDesc': 'Το τιμολόγιο που αναζητάτε δεν υπάρχει ή δεν έχετε άδεια να το δείτε.',
    'invoicePayment.returnHome': 'Επιστροφή στην Αρχική',
    'invoicePayment.backHome': 'Πίσω στην Αρχική',
    'invoicePayment.title': 'Τιμολόγιο {{key}}',
    'invoicePayment.created': 'Δημιουργήθηκε {{timeAgo}}',
    'invoicePayment.summary': 'Περίληψη Τιμολογίου',
    'invoicePayment.paid': 'Πλήρως Πληρωμένο',
    'invoicePayment.due': 'Πληρωμή Ληξιπρόθεσμη',
    'invoicePayment.totalAmount': 'Συνολικό Ποσό',
    'invoicePayment.amountPaid': 'Ποσό Πληρωμένο',
    'invoicePayment.amountDue': 'Ποσό Ληξιπρόθεσμο',
    'invoicePayment.paymentsMade': 'Πληρωμές που Έγιναν',
    'invoicePayment.description': 'Περιγραφή',
    'invoicePayment.expires': 'Λήγει',
    'invoicePayment.history': 'Ιστορικό Πληρωμών',
    'invoicePayment.received': 'Πληρωμή λήφθηκε',
    'invoicePayment.from': 'από {{name}}',
    'invoicePayment.paidTitle': 'Το Τιμολόγιο Πληρώθηκε',
    'invoicePayment.paidDesc': 'Αυτό το τιμολόγιο έχει πληρωθεί πλήρως. Ευχαριστούμε!',
    'invoicePayment.toast.error': 'Σφάλμα',
    'invoicePayment.toast.errorDesc': 'Αποτυχία φόρτωσης λεπτομερειών τιμολογίου.',
    'invoicePayment.toast.success': 'Η Πληρωμή Ολοκληρώθηκε με Επιτυχία',
    'invoicePayment.toast.successDesc': 'Πληρώθηκε με επιτυχία το τιμολόγιο {{key}}',
    'invoicePayment.toast.fail': 'Η Πληρωμή Απέτυχε',
    'invoicePayment.toast.failDesc': 'Αποτυχία επεξεργασίας πληρωμής. Παρακαλώ δοκιμάστε ξανά.',
  },
  de: {
    'invoicePayment.loading': 'Rechnungsdetails werden geladen...',
    'invoicePayment.notFound': 'Rechnung nicht gefunden',
    'invoicePayment.notFoundDesc': 'Die gesuchte Rechnung existiert nicht oder Sie haben keine Berechtigung, sie anzuzeigen.',
    'invoicePayment.returnHome': 'Zurück zur Startseite',
    'invoicePayment.backHome': 'Zurück zur Startseite',
    'invoicePayment.title': 'Rechnung {{key}}',
    'invoicePayment.created': 'Erstellt {{timeAgo}}',
    'invoicePayment.summary': 'Rechnungsübersicht',
    'invoicePayment.paid': 'Vollständig bezahlt',
    'invoicePayment.due': 'Zahlung fällig',
    'invoicePayment.totalAmount': 'Gesamtbetrag',
    'invoicePayment.amountPaid': 'Bezahlter Betrag',
    'invoicePayment.amountDue': 'Fälliger Betrag',
    'invoicePayment.paymentsMade': 'Getätigte Zahlungen',
    'invoicePayment.description': 'Beschreibung',
    'invoicePayment.expires': 'Läuft ab',
    'invoicePayment.history': 'Zahlungsverlauf',
    'invoicePayment.received': 'Zahlung erhalten',
    'invoicePayment.from': 'von {{name}}',
    'invoicePayment.paidTitle': 'Rechnung bezahlt',
    'invoicePayment.paidDesc': 'Diese Rechnung wurde vollständig bezahlt. Vielen Dank!',
    'invoicePayment.toast.error': 'Fehler',
    'invoicePayment.toast.errorDesc': 'Rechnungsdetails konnten nicht geladen werden.',
    'invoicePayment.toast.success': 'Zahlung erfolgreich',
    'invoicePayment.toast.successDesc': 'Rechnung {{key}} erfolgreich bezahlt',
    'invoicePayment.toast.fail': 'Zahlung fehlgeschlagen',
    'invoicePayment.toast.failDesc': 'Zahlung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
  },
  ro: {
    'invoicePayment.loading': 'Se încarcă detaliile facturii...',
    'invoicePayment.notFound': 'Factură Negăsită',
    'invoicePayment.notFoundDesc': 'Factura pe care o căutați nu există sau nu aveți permisiunea să o vizualizați.',
    'invoicePayment.returnHome': 'Înapoi la Acasă',
    'invoicePayment.backHome': 'Înapoi la Acasă',
    'invoicePayment.title': 'Factură {{key}}',
    'invoicePayment.created': 'Creată {{timeAgo}}',
    'invoicePayment.summary': 'Rezumat Factură',
    'invoicePayment.paid': 'Plătită Complet',
    'invoicePayment.due': 'Plată Datorată',
    'invoicePayment.totalAmount': 'Suma Totală',
    'invoicePayment.amountPaid': 'Suma Plătită',
    'invoicePayment.amountDue': 'Suma Datorată',
    'invoicePayment.paymentsMade': 'Plăți Efectuate',
    'invoicePayment.description': 'Descriere',
    'invoicePayment.expires': 'Expiră',
    'invoicePayment.history': 'Istoric Plăți',
    'invoicePayment.received': 'Plată primită',
    'invoicePayment.from': 'de la {{name}}',
    'invoicePayment.paidTitle': 'Factură Plătită',
    'invoicePayment.paidDesc': 'Această factură a fost plătită complet. Mulțumim!',
    'invoicePayment.toast.error': 'Eroare',
    'invoicePayment.toast.errorDesc': 'Nu s-a putut încărca detaliile facturii.',
    'invoicePayment.toast.success': 'Plată Reușită',
    'invoicePayment.toast.successDesc': 'Plătit cu succes pentru factura {{key}}',
    'invoicePayment.toast.fail': 'Plată Eșuată',
    'invoicePayment.toast.failDesc': 'Nu s-a putut procesa plata. Vă rugăm să încercați din nou.',
  },
  sr: {
    'invoicePayment.loading': 'Учитавање детаља фактуре...',
    'invoicePayment.notFound': 'Фактура није пронађена',
    'invoicePayment.notFoundDesc': 'Фактура коју тражите не постоји или немате дозволу да је видите.',
    'invoicePayment.returnHome': 'Повратак на почетну',
    'invoicePayment.backHome': 'Назад на почетну',
    'invoicePayment.title': 'Фактура {{key}}',
    'invoicePayment.created': 'Креирано {{timeAgo}}',
    'invoicePayment.summary': 'Резиме фактуре',
    'invoicePayment.paid': 'Плаћено у целости',
    'invoicePayment.due': 'Доспело за плаћање',
    'invoicePayment.totalAmount': 'Укупан износ',
    'invoicePayment.amountPaid': 'Плаћени износ',
    'invoicePayment.amountDue': 'Износ за плаћање',
    'invoicePayment.paymentsMade': 'Извршена плаћања',
    'invoicePayment.description': 'Опис',
    'invoicePayment.expires': 'Истиче',
    'invoicePayment.history': 'Историја плаћања',
    'invoicePayment.received': 'Примљена уплата',
    'invoicePayment.from': 'од {{name}}',
    'invoicePayment.paidTitle': 'Фактура плаћена',
    'invoicePayment.paidDesc': 'Ова фактура је плаћена у целости. Хвала вам!',
    'invoicePayment.toast.error': 'Грешка',
    'invoicePayment.toast.errorDesc': 'Није успело учитавање детаља фактуре.',
    'invoicePayment.toast.success': 'Плаћање успешно',
    'invoicePayment.toast.successDesc': 'Успешно плаћена фактура {{key}}',
    'invoicePayment.toast.fail': 'Плаћање неуспешно',
    'invoicePayment.toast.failDesc': 'Обрада плаћања није успела. Покушајте поново.',
  },
  pl: {
    'invoicePayment.loading': 'Ładowanie szczegółów faktury...',
    'invoicePayment.notFound': 'Faktura Nie Znaleziona',
    'invoicePayment.notFoundDesc': 'Faktura, której szukasz, nie istnieje lub nie masz uprawnień do jej wyświetlenia.',
    'invoicePayment.returnHome': 'Powrót do Strony Głównej',
    'invoicePayment.backHome': 'Powrót do Strony Głównej',
    'invoicePayment.title': 'Faktura {{key}}',
    'invoicePayment.created': 'Utworzona {{timeAgo}}',
    'invoicePayment.summary': 'Podsumowanie Faktury',
    'invoicePayment.paid': 'W Pełni Opłacona',
    'invoicePayment.due': 'Płatność Wymagana',
    'invoicePayment.totalAmount': 'Całkowita Kwota',
    'invoicePayment.amountPaid': 'Kwota Opłacona',
    'invoicePayment.amountDue': 'Kwota Do Zapłaty',
    'invoicePayment.paymentsMade': 'Wykonane Płatności',
    'invoicePayment.description': 'Opis',
    'invoicePayment.expires': 'Wygasa',
    'invoicePayment.history': 'Historia Płatności',
    'invoicePayment.received': 'Płatność otrzymana',
    'invoicePayment.from': 'od {{name}}',
    'invoicePayment.paidTitle': 'Faktura Opłacona',
    'invoicePayment.paidDesc': 'Ta faktura została w pełni opłacona. Dziękujemy!',
    'invoicePayment.toast.error': 'Błąd',
    'invoicePayment.toast.errorDesc': 'Nie udało się załadować szczegółów faktury.',
    'invoicePayment.toast.success': 'Płatność Zakończona Sukcesem',
    'invoicePayment.toast.successDesc': 'Pomyślnie opłacono fakturę {{key}}',
    'invoicePayment.toast.fail': 'Płatność Nie Powiodła Się',
    'invoicePayment.toast.failDesc': 'Nie udało się przetworzyć płatności. Proszę spróbować ponownie.',
  },
};
